/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_RuInputs */

const en_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const es_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const de_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const zh_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const ar_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const fr_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const vi_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const sw_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const th_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const bs_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const ja_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const ko_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const pt_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const it_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const sv_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const nl_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const da_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const nb_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const fi_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const pl_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const ru_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const tr_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const hi_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const id_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const ms_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const cs_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const el_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const he_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const af_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

const hu_nav_language_ru = /** @type {(inputs: Nav_Language_RuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Русский`)
};

/**
* | output |
* | --- |
* | "Русский" |
*
* @param {Nav_Language_RuInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_ru = /** @type {((inputs?: Nav_Language_RuInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_RuInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_ru(inputs)
	if (locale === "de") return de_nav_language_ru(inputs)
	if (locale === "zh") return zh_nav_language_ru(inputs)
	if (locale === "ar") return ar_nav_language_ru(inputs)
	if (locale === "fr") return fr_nav_language_ru(inputs)
	if (locale === "vi") return vi_nav_language_ru(inputs)
	if (locale === "sw") return sw_nav_language_ru(inputs)
	if (locale === "th") return th_nav_language_ru(inputs)
	if (locale === "bs") return bs_nav_language_ru(inputs)
	if (locale === "ja") return ja_nav_language_ru(inputs)
	if (locale === "ko") return ko_nav_language_ru(inputs)
	if (locale === "pt") return pt_nav_language_ru(inputs)
	if (locale === "it") return it_nav_language_ru(inputs)
	if (locale === "sv") return sv_nav_language_ru(inputs)
	if (locale === "nl") return nl_nav_language_ru(inputs)
	if (locale === "da") return da_nav_language_ru(inputs)
	if (locale === "nb") return nb_nav_language_ru(inputs)
	if (locale === "fi") return fi_nav_language_ru(inputs)
	if (locale === "pl") return pl_nav_language_ru(inputs)
	if (locale === "ru") return ru_nav_language_ru(inputs)
	if (locale === "tr") return tr_nav_language_ru(inputs)
	if (locale === "hi") return hi_nav_language_ru(inputs)
	if (locale === "id") return id_nav_language_ru(inputs)
	if (locale === "ms") return ms_nav_language_ru(inputs)
	if (locale === "cs") return cs_nav_language_ru(inputs)
	if (locale === "el") return el_nav_language_ru(inputs)
	if (locale === "he") return he_nav_language_ru(inputs)
	if (locale === "af") return af_nav_language_ru(inputs)
	if (locale === "hu") return hu_nav_language_ru(inputs)
	return en_nav_language_ru(inputs)
});